<template>
    <div id="wrong">
        <headers :title='titles'></headers>
        <div class="tips">
            收录同步习题、单元复习中班级试题错误率高于30%的试题<span v-if="DataList.length">（每周五更新）</span>
        </div>
        <div v-if="loading">
            <div v-if="DataList.length">
                <ul class="list">
                    <li class="clearfix"
                        v-for="(data,index) in DataList">
                        <div class="left_title">
                            <span class="name">
                                {{data.add_date | dateFormat('YYYY-MM-DD')}}（{{data.ask_num}}题）
                            </span>
                            <span class="YL_btn"
                                  @click="toPreview(data,0)">预览</span>
                        </div>
                        <div class="add_btn"
                             v-if="!data.choose"
                             @click="add(data,index)">加入</div>
                        <div class="dele_btn"
                             v-else
                             @click="dele(data,index)">移除</div>
                    </li>
                </ul>
                <div v-if='test_num==0'
                     :class="['bottom_btn',{'able':test_num>0,'disable':test_num==0}]">已选{{test_num}}题，点击预览
                </div>
                <div v-else
                     @click="toPreview(0,1)"
                     :class="['bottom_btn',{'able':test_num>0,'disable':test_num==0}]">
                    已选{{test_num}}题，点击预览
                </div>
            </div>
            <div v-else
                 class="no_wrong">
                <i class="noWrong_icon"></i>
                <p>您的班级暂无高频错题<br />（每周五更新）</p>
            </div>
        </div>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from 'SRC/components/base/header.vue';
import loadingS from 'SRC/components/base/tealoading.vue';

export default {
    data () {
        return {
            titles: '高频错题',
            test_num: 0,//已选试题数量
            DataList: [],
            chooseData: [],//选中的信息
            loading: false,
            sid: this.$route.params.sid,
        }
    },
    created () {
        let math_send_ok = localStorage.getItem('math_send_ok');
        if (math_send_ok == 1) {
            this.$router.go(-1);
            return false;
        }
        this.$http.post(API_URL_TASK_API + '/public/task/high/wrong/list', { sid: this.sid }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.DataList = res.data;
                this.loading = true;
            }
        })
    },
    components: {
        headers,
        loadingS
    },
    computed: {},
    methods: {
        toPreview (data, type) {

            if (!type) {
                this.$store.commit('setWrong', data.list)
                this.$router.push('/sx/wrong/preview/' + this.sid + '/0?name=' + data.add_date);
            } else {
                this.DataList.forEach((m, n) => {
                    if (m.choose) {
                        m.list.forEach((l, i) => {
                            this.chooseData.push(l)
                        })
                    }
                })
                var hash = {};
                this.chooseData = this.chooseData.reduce((item, next) => {
                    hash[next.qid] ? '' : hash[next.qid] = true && item.push(next);
                    return item
                }, [])
                this.$store.commit('setWrong', this.chooseData)
                this.$router.push('/sx/wrong/preview/' + this.sid + '/1');
            }

        },
        add (data, index) {
            this.DataList[index].choose = true;
            this.DataList.splice(index, 1, this.DataList[index]);
            data.list.forEach((m, n) => {
                this.chooseData.push(m)
            })
            this.test_num = this.test_num + data.ask_num;
        },
        dele (data, index) {
            this.DataList[index].choose = false;
            this.DataList.splice(index, 1, this.DataList[index]);
            this.test_num = this.test_num - data.ask_num;
        }
    }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

#wrong {
    font-size: 30px / $ppr;
}

.tips {
    line-height: 45px / $ppr;
    padding: 20px / $ppr 25px / $ppr;
    color: #999;
    background: #fff;
    margin-bottom: 25px / $ppr;
}

.list {
    width: 100%;
    padding-bottom: 100px / $ppr;
    li {
        line-height: 96px / $ppr;
        border-bottom: 1px / $ppr solid #e8e8e8;
        background: #fff;
        .left_title {
            float: left;
            padding-left: 25px / $ppr;
            width: 400px / $ppr;
            span {
                display: inline-block;
            }
            .YL_btn {
                width: 80px / $ppr;
                color: $c-theme;
            }
            .pass {
                color: #999;
            }
        }
        .add_btn {
            float: right;
            border: 1px / $ppr solid $c-theme;
            border-radius: 24px / $ppr;
            color: $c-theme;
            line-height: 48px / $ppr;
            height: 48px / $ppr;
            width: 122px / $ppr;
            text-align: center;
            margin: 22px / $ppr 25px / $ppr 0 0;
        }
        .dele_btn {
            float: right;
            // padding-right:25px/$ppr;
            border: 1px / $ppr solid #ff6600;
            border-radius: 24px / $ppr;
            color: #ff6600;
            line-height: 48px / $ppr;
            height: 48px / $ppr;
            width: 122px / $ppr;
            text-align: center;
            margin: 22px / $ppr 25px / $ppr 0 0;
        }
        &:last-child {
            border-bottom: none;
        }
    }
}

.bottom_btn {
    width: 100%;
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    font-size: 32px / $ppr;
    text-align: center;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
}

.disable {
    background: #ccc;
    color: #999;
}

.able {
    background: #5e89ef;
    color: #fff;
}

.no_wrong {
    text-align: center;
    color: #333;
    margin-top: 200px / $ppr;
    line-height: 50px / $ppr;
    .noWrong_icon {
        display: block;
        width: 163px / $ppr;
        height: 107px / $ppr;
        background: url("./img/icon_notest.png") 0 0 no-repeat;
        background-size: 100% 100%;
        margin: 0 auto 27px / $ppr;
    }
}
</style>
